import InfoIcon from '@mui/icons-material/Info';

export default InfoIcon;
